import { defineMessages } from "react-intl";

export default defineMessages({
  info_01: {
    id: "wizard.info_01",
    defaultMessage:
      "Seuraavat kohdat on jaoteltu ammatillisten tutkintojen ja koulutuksen järjestämisluvan rakenteen mukaisesti. Hakijan tulee täyttää alla olevat kohdat vain siltä osin, mihin tutkintojen ja koulutuksen järjestämislupaan haetaan muutosta. Tarkemmat ohjeistukset sekä pykäläviittaukset ammatillisen koulutuksen lakiin (531/2017) on esitetty kohdittain."
  },
  info_02: {
    id: "wizard.info_02",
    defaultMessage:
      "Koulutuksen järjestäjä voi järjestää myös em. tutkintoihin liittyvää ammatillisesta koulutuksesta annetun (531/2017) 8 §:n 1 kohdassa tarkoitettua ammatillista osaamista syventävää tai täydentävää koulutusta."
  },
  formTitle_new: {
    id: "wizard.formTitle_new",
    defaultMessage: "Uusi hakemus"
  },
  pageTitle_1: {
    id: "wizard.pageTitle_1",
    defaultMessage: "Uusi muutoshakemus"
  },
  pageTitle_2: {
    id: "wizard.pageTitle_2",
    defaultMessage: "Perustelut"
  },
  pageTitle_3: {
    id: "wizard.pageTitle_3",
    defaultMessage: "Taloudelliset edellytykset"
  },
  pageTitle_4: {
    id: "wizard.pageTitle_4",
    defaultMessage: "Yhteenveto"
  },
  sectionTitle_1: {
    id: "wizard.sectionTitle_1",
    defaultMessage: "Tutkinnot ja koulutukset"
  },
  teachingLanguages: {
    id: "wizard.teachingLanguages",
    defaultMessage: "Opetuskielet"
  },
  preparatoryTraining: {
    id: "wizard.preparatoryTraining",
    defaultMessage: "Valmentavat koulutukset"
  },
  driverTraining: {
    id: "wizard.driverTraining",
    defaultMessage: "Kuljettajakoulutukset"
  },
  workforceTraining: {
    id: "wizard.workforceTraining",
    defaultMessage: "Työvoimakoulutukset"
  },
  vocationalTraining: {
    id: "wizard.vocationalTraining",
    defaultMessage: "Ammatilliseen tehtävään valmistavat koulutukset"
  },
  chooseOnlyOne: {
    id: "wizard.chooseOnlyOne",
    defaultMessage: "Voit valita vain yhden seuraavista:"
  },
  chooseAdditional: {
    id: "wizard.chooseAdditional",
    defaultMessage: "Lisäksi voit valita seuraavat:"
  },
  header_section1: {
    id: "wizard.header_section1",
    defaultMessage: "Tutkinnot ja koulutukset"
  },
  header_section2: {
    id: "wizard.header_section2",
    defaultMessage: "Opetus- ja tutkintokieli"
  },
  header_section3: {
    id: "wizard.header_section3",
    defaultMessage: "Toiminta-alue"
  },
  header_section4: {
    id: "wizard.header_section4",
    defaultMessage: "Opiskelijavuodet ja niitä koskevat rajoitukset"
  },
  header_section5: {
    id: "wizard.header_section5",
    defaultMessage: "Muut oikeudet, velvollisuudet, ehdot ja tehtävät"
  },
  other_placeholder: {
    id: "wizard.other_placeholder",
    defaultMessage: "Kerro vapaasti, mitä haluat hakea"
  },
  minimumAmountOfYears: {
    id: "wizard.minimumAmountOfYears",
    defaultMessage: "Koulutuksen järjestäjän opiskelijavuosien vähimmäismäärä"
  },
  maximumAmountOfYears: {
    id: "wizard.maximumAmountOfYears",
    defaultMessage:
      "Niiden opiskelijoiden osalta, jotka eivät ole oppivelvollisuuslain (1214/2020) 16 §:n nojalla oikeutettuja maksuttomaan koulutukseen, rahoituksen perusteena oleva opiskelijavuosien enimmäismäärä on"
  },
  noMaxYears: {
    id: "wizard.noMaxYears",
    defaultMessage:
      "Koulutuksen järjestäjälle ei määritetä opiskelijavuosien enimmäismäärää."
  },
  limitForSpecialSupport: {
    id: "wizard.limitForSpecialSupport",
    defaultMessage:
      "Vähimmäisopiskelijavuosimäärän rajoitus koskien vaativaa erityistä tukea (65 §)"
  },
  limitForBoardingSchool: {
    id: "wizard.limitForBoardingSchool",
    defaultMessage:
      "Vähimmäisopiskelijavuosimäärän rajoitus koskien sisäoppilaitosmuotoista koulutusta (27 §)"
  },
  responsibilities: {
    id: "wizard.responsibilities",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta Ahvenanmaan maakuntaa lukuunottamatta koko Suomen osaamis- ja koulutustarpeeseen."
  },
  areasInfo1: {
    id: "wizard.areasInfo1",
    defaultMessage: "Tähän lyhyt ohjeteksti kohteen täyttämisestä"
  },
  areasInfo2: {
    id: "wizard.areasInfo2",
    defaultMessage: "Tähän lyhyt ohjeteksti toimialueiden valintaan liittyen"
  },
  areasInfo3: {
    id: "wizard.areasInfo3",
    defaultMessage: "Tähän lyhyt ohjeteksti valtakunnallisen valintaan liittyen"
  },
  noArea: {
    id: "wizard.noArea",
    defaultMessage: "Toiminta-aluetta ei määritetty"
  },
  municipalities: {
    id: "wizard.municipalities",
    defaultMessage: "Kunnat"
  },
  counties: {
    id: "wizard.counties",
    defaultMessage: "Maakunnat"
  },
  previous: {
    id: "wizard.previous",
    defaultMessage: "Edellinen"
  },
  next: {
    id: "wizard.next",
    defaultMessage: "Seuraava"
  },
  saveDraft: {
    id: "wizard.saveDraft",
    defaultMessage: "Tallenna luonnos"
  },
  send: {
    id: "wizard.send",
    defaultMessage: "Lähetä hakemus"
  },
  preview: {
    id: "wizard.preview",
    defaultMessage: "Esikatsele"
  },
  noChanges: {
    id: "wizard.noChanges",
    defaultMessage: "Ei muutoksia."
  },
  noAddedTutkinnot: {
    id: "wizard.noAddedTutkinnot",
    defaultMessage:
      "Taloudelliset edellytykset ilmoitetaan vain, kun järjestämislupaan haetaan uusia tutkintoja tai koulutuksia. Jatka seuraavalle välilehdelle Seuraava-painikkeella."
  },
  except: {
    id: "wizard.except",
    defaultMessage: "lukuun ottamatta:"
  },
  osaamisalarajoitus: {
    id: "wizard.osaamisalarajoitus",
    defaultMessage: "Rajoitus"
  },
  kuljettajakoulutusOutOfScope: {
    id: "wizard.kuljettajakoulutusOutOfScope",
    defaultMessage:
      "Ei oikeutta järjestää kuorma- ja linja-autonkuljettajan ammattipätevyyskoulutusta"
  },
  notSignedIn: {
    id: "wizard.notSignedIn",
    defaultMessage: "Uuden hakemuksen tekeminen vaatii kirjautumisen palveluun."
  },
  noRights: {
    id: "wizard.noRights",
    defaultMessage: "Sinulla ei ole oikeuksia tälle sivulle."
  },
  tutkintokielet: {
    id: "wizard.tutkintokielet",
    defaultMessage: "Tutkintokielet"
  },
  allFieldsRequired: {
    id: "wizard.allFieldsRequired",
    defaultMessage: "Täydennä kaikki tämän sivun kentät."
  },
  allPerustelutRequired: {
    id: "wizard.allPerustelutRequired",
    defaultMessage: "Perustele kaikki muutokset."
  },
  otherAttachments: {
    id: "wizard.otherAttachments",
    defaultMessage: "Muut liitteet"
  },
  getOut: {
    id: "wizard.getOut",
    defaultMessage: "Poistu"
  },
  getOutPreview: {
    id: "wizard.getOutPreview",
    defaultMessage: "Poistu esikatselusta"
  },
  previewAndPrint: {
    id: "wizard.previewAndPrint",
    defaultMessage: "Esikatsele ja tulosta"
  },
  esittelijatMuutospyyntoDialogTitle: {
    id: "wizard.esittelijatMuutospyyntoDialogTitle",
    defaultMessage: "Päätöksen valmistelu: Järjestämisluvan muutos"
  },
  singularMunicipalitiesOrTheWholeCountry: {
    id: "wizard.singularMunicipalitiesOrTheWholeCountry",
    defaultMessage: "Yksittäiset maakunnat ja kunnat tai koko maa"
  },
  ofMunicipalities: {
    id: "wizard.ofMunicipalities",
    defaultMessage: "kunnista"
  },
  sameAsTheCurrentAreaOfAction: {
    id: "wizard.sameAsTheCurrentAreaOfAction",
    defaultMessage: "Sama kuin nykyinen toiminta-alue"
  },
  newAreaOfAction: {
    id: "wizard.newAreaOfAction",
    defaultMessage: "Uusi toiminta-alue"
  },
  currentAreaOfAction: {
    id: "wizard.currentAreaOfAction",
    defaultMessage: "Nykyinen toiminta-alue"
  },
  wholeCountryWithoutAhvenanmaa: {
    id: "wizard.wholeCountryWithoutAhvenanmaa",
    defaultMessage: "Koko Suomi - pois lukien Ahvenanmaan maakunta"
  },
  areaOfActionIsUndefined: {
    id: "wizard.areaOfActionIsUndefined",
    defaultMessage: "Ei määriteltyä toiminta-aluetta"
  },
  yleisetTiedot: {
    id: "wizard.yleisetTiedot",
    defaultMessage: "Yleiset tiedot"
  },
  taloudellisetInvestoinnit: {
    id: "wizard.taloudellisetInvestoinnit",
    defaultMessage: "Taloudelliset investoinnit"
  },
  taloudellisetTilinpaatostiedot: {
    id: "wizard.taloudellisetTilinpaatostiedot",
    defaultMessage: "Taloudelliset tilinpäätöstiedot"
  },
  liitteet: {
    id: "wizard.liitteet",
    defaultMessage: "Liitteet"
  },
  municipalitiesAndAreas: {
    id: "wizard.municipalitiesAndAreas",
    defaultMessage: "Kunnat ja alueet"
  },
  noMunicipalitiesSelected: {
    id: "wizard.noMunicipalitiesSelected",
    defaultMessage: "Ei valittuja kuntia"
  },
  selectMunicipalities: {
    id: "wizard.selectMunicipalities",
    defaultMessage: "Valitse kunnat"
  },
  editAreaOfAction: {
    id: "wizard.editAreaOfAction",
    defaultMessage: "Muokkaa toiminta-aluetta"
  },
  municipalitiesInPresentLupa: {
    id: "wizard.municipalitiesInPresentLupa",
    defaultMessage: "Nykyisen luvan kunnat"
  },
  municipalitiesInNewLupa: {
    id: "wizard.municipalitiesInNewLupa",
    defaultMessage: "Uuden luvan kunnat"
  },
  closePreview: {
    id: "wizard.closePreview",
    defaultMessage: "Sulje esikatselu"
  },
  luvanKorjaustilaJarjestamisluvanMuutos: {
    id: "wizard.luvanKorjaustilaJarjestamisluvanMuutos",
    defaultMessage: "LUVAN KORJAUSTILA: Järjestämisluvan muutos"
  },
  luvanTaiteenalat: {
    id: "wizard.luvanTaiteenalat",
    defaultMessage: "Luvan taiteenalat"
  },
  muutKunnatOppilaspaikkojenVaraaminen: {
    id: "wizard.muutKunnatOppilaspaikkojenVaraaminen",
    defaultMessage: "Muut kunnat (oppilaspaikkojen varaaminen)"
  }
});
